var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-address-list',{attrs:{"list":_vm.list,"default-tag-text":"默认"},on:{"add":_vm.onAdd,"edit":_vm.onEdit,"select":_vm.clickItem},model:{value:(_vm.chosenAddressId),callback:function ($$v) {_vm.chosenAddressId=$$v},expression:"chosenAddressId"}}),_vm._v(" "),_c('Floating'),_vm._v(" "),_c('wxNoShare')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19730610","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/users/address.vue
// module id = null
// module chunks = 